// extracted by mini-css-extract-plugin
module.exports = {"timeRemaining":"remaining-time_timeRemaining__26xlT"};